(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dor-heim-technical-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dor-heim-tabs')) {
    customElements.define('dor-heim-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        const select = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); select(next, true); }
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dor-spacer-technical-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dor-spacer-tabs')) {
    customElements.define('dor-spacer-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        const select = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); select(next, true); }
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
